/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type Plan = (typeof Plan)[keyof typeof Plan]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Plan = {
  STARTER: 'STARTER',
  STANDARD: 'STANDARD',
  PROFESSIONAL: 'PROFESSIONAL',
} as const
